import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { scroller } from 'react-scroll';
import BtnMembership from '../BtnMembership/';
import './MembershipCard.scss';

function MembershipCard({
    type,
    title,
    cost,
    textBtn,
    infoMembership,
    handleClick,
    disabledLines,
    resume,
    moreInfoLink,
    yearly,
    oldCost,
}) {

  const dropDown = '/img/arrows/light-arrows/drop-down.svg'
  const dropUp = '/img/arrows/light-arrows/drop-up.svg'
  const greenTag = '/img/membership/modal/green-tag.svg'

  const [ hovered, setHovered ] = useState(false)
  const [ expanded, setExpanded ] = useState(false)

  const handleExpanded = () => {
    if (expanded) {
        scroller.scrollTo('mship-card', { smooth: true, offset: -64 });
    }
    setExpanded(!expanded)
  }

  return (
    <div
        id='mship-card'
        className='mship-card'
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
    >
        <div className='mship-card_topbar' />
        <div className='mship-card_container'>
            {yearly ?
                <div className='mship-card_container_tagContainer'>
                    <p className='mship-card_container_tagContainer-text'>
                        MENOS 20%
                    </p>
                    <img
                        className='mship-card_container_tagContainer-tag'
                        src={greenTag}
                        alt='discount'
                    />
                </div> : null
            }
            <p className='mship-card_container_title'>
                {title}
            </p>
            <p className='mship-card_container_subtitle'>
                PREMIUM
            </p>
            {!disabledLines && <hr className='line-inCard'/>}
            <p className='mship-card_container_explanation'>
                Por una inversión {yearly ? 'anual' : 'mensual'} de
            </p>
            {oldCost ?
                <p className='mship-card_container_oldPrice'>
                    ${oldCost}<span className='oldSmallTitle'>.-MXN</span>
                </p> : null
            }
            <p className='mship-card_container_price'>
                ${cost}<span className='smallTitle'>.-MXN</span>
            </p>
            <p className='mship-card_description'>
                {yearly ?
                    'Más IVA, en una sola exhibición' :
                    'Más IVA, facturado mensualmente / Permanencia de 12 meses'
                }
            </p>
            {/* {resume &&
                <p className='mship-card_resume'>{resume}</p>
            } */}
            {moreInfoLink &&
                <Link
                    className='mship-card_infoLink'
                    to={moreInfoLink}
                >
                    Más información
                </Link>
            }
            <BtnMembership
                textBtn={textBtn}
                handleClick={handleClick}
                hovered={hovered}
            />
            {/* {!disabledLines && <hr className='line-inCard'/>} */}
            {infoMembership && infoMembership.map((item, index)=>{
                return (
                    <div key={index} className='mship-card_features'>
                        {index <= 4 || expanded ?
                            <>
                                <hr className='line-inCard'/>
                                {item}
                            </> :
                            null
                        }
                        {(infoMembership.length - 1) === index ?
                            <hr className='line-inCard'/> : null
                        }
                    </div>
                )
            })}

            {infoMembership &&
            infoMembership.length &&
            infoMembership.length > 5 ?
                <div
                    className='mship-card_knowMore'
                    onClick={handleExpanded}
                >
                    <p className='mship-card_knowMore-title'>
                        {expanded ? 'Ver menos' : 'Conoce más beneficios'}
                    </p>
                    <img
                        src={expanded ? dropUp : dropDown}
                        className='mship-card_knowMore-img'
                        alt='arrow'
                    />
                </div> : null
            }
        </div>
    </div>
  );
}

export default MembershipCard;
